import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantStore from '../../../../ParticipantStore';
import ParticipantsStore from '../../../../ParticipantsStore';
import Body from './Body';
import Head from './Head';

interface Props {
  participantStores: ReadonlyArray<ParticipantStore>;
  participantsStore: ParticipantsStore;
  licenseFamily: LicenseFamily;
}

function ParticipantsTable({ participantStores, participantsStore, licenseFamily }: Props) {
  return (
    <table className="min-w-full divide-y divide-gray-300">
      <Head store={participantsStore} licenseFamily={licenseFamily} />
      <Body
        store={participantsStore}
        participantStores={participantStores}
        licenseFamily={licenseFamily}
      />
    </table>
  );
}

export default observer(ParticipantsTable);
